<template>
  <div class="picture-container">
    <div
      v-for="(items, itemsIndex) in displayLists"
      :key="itemsIndex"
      class="picture-line"
    >
      <div
        v-for="(item,index) in items"
        :key="index"
        :class="imageCount > 2 ? 'picture-item' : 'picture-item large-img'"
        >
        <template v-if="item.target_url">
          <i class="middle_i" ></i>
          <a target="_blank" :href="item.target_url.startsWith('http') ? item.target_url : 'http://' + item.target_url.trim()">
            <img ref="bannerHeight" :src="getFilePath(item.resource_key)">
          </a>
          <ExpandCollapse
            v-if="item.description"
            :lineHeight="textLineHeight"
            :content="item.description"
            :minDisplayLines="4"
            class="picture-description"
            />
        </template>
        <template v-else>
          <i class="middle_i" ></i>
          <a>
            <img class="no-url" ref="bannerHeight" :src="getFilePath(item.resource_key)">
          </a>
          <ExpandCollapse
            v-if="item.description"
            :lineHeight="textLineHeight"
            :content="item.description"
            :minDisplayLines="4"
            class="picture-description"
            />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ExpandCollapse from '@/components/common/text/expandCollapse.vue'
import { getFilePath } from '@/utils/qiniu'

export default {
  components: {
    ExpandCollapse
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      textLineHeight: 30
    }
  },
  computed: {
    displayLists () {
      if (this.value?.items?.length > 0) {
        return _.chunk(this.value.items, 3)
      }
      return []
    },
    imageCount () {
      return this.value?.items?.length || 0
    }
  },
  created () {
  },
  methods: {
    getFilePath (key) {
      return getFilePath(key)
    }
  }
}
</script>

<style lang="scss" scoped>
.picture-container {
  .picture-line {
    margin-bottom: 62px;
    display: flex;
    width: 100%;
    justify-content: space-between;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .picture-item {
    display: flex;
    flex-direction: column;

    .no-url {
      cursor: default;
    }

    img {
      width: 308px;
    }

    .picture-description {
      width: 308px;
      margin: 13px 0 0 0;

    }
    ::v-deep .expand-collapse-container{
      .content-container {
        margin-bottom: 0px;

        .content {
          line-height: 2;
        }
      }

      .button-container {
        margin-top: 20px;
      }
    }

    &.large-img {
      .picture-description {
        width: 476px;
      }

      img {
        width: 476px;
      }
    }
  }
}
</style>
